import React from 'react';

/**
 * withEmphasis — `**bold**` → `<b>`. SINGLE renderer for a copy source's own
 * emphasis markers (e.g. "**No money is collected now**"), shared by every
 * surface that renders one of these strings — the diagnostic-waiver record
 * dialog, the bill line, the Diagnostics tab hint — so none of them
 * re-derives its own markdown parsing. The copy source itself stays plain
 * strings; this is the ONLY place that syntax is interpreted.
 */
export function withEmphasis(text) {
  return String(text || '').split('**').map((part, i) => (
    // eslint-disable-next-line react/no-array-index-key
    i % 2 === 1 ? <b key={i}>{part}</b> : <React.Fragment key={i}>{part}</React.Fragment>
  ));
}

export default withEmphasis;
